export default "__VITE_ASSET__BBZfR0Iz__"